export default class Gender {
  constructor (data) {
    this.id = data.id
    this.nameFr = data.nameFr
  }
}
